<template>
  <nav>
    <v-list :style="`background-color:` + question.bg_color" :class="role == 'booster' ? 'disable-events' : ''">
      <v-list-item v-for="answer in question.options" :key="answer.aid" class="no-hover"
        :class="answer.answer ? 'selected' : 'not-selected'" :ripple="false"
        @click="role == 'booster' ? '' : answerQuestion(answer)">
        <v-text-field v-if="role == 'booster'" disabled readonly dense solo elevation="8"
          class="survey-answer-block rounded-lg text-body-2" hide-details="auto">
          <template v-slot:prepend-inner>
            <v-icon class="icon-des my-2" color="greytext">mdi-checkbox-blank-outline</v-icon>
            <p data-testid="select-answer"
              class="font-weight-regular greytext--text text-body-2 my-2 ml-2 align-self-center no-break">
              {{ answer.option }}
            </p>
          </template>
        </v-text-field>
        <v-text-field v-else readonly dense solo elevation="8" class="survey-answer-block rounded-lg text-body-2"
          hide-details="auto" :key="updateComponent">
          <template v-slot:prepend-inner>
            <v-icon v-if="answer.answer" class="icon-des my-2 row-pointer" color="greytext">mdi-checkbox-outline</v-icon>
            <v-icon v-else class="icon-des my-2 row-pointer" color="greytext">mdi-checkbox-blank-outline</v-icon>
            <p data-testid="select-answer"
              class="font-weight-regular greytext--text text-body-2 my-2 ml-2 align-self-center no-break row-pointer">
              {{ answer.option }}
            </p>
          </template>
        </v-text-field>
      </v-list-item>
    </v-list>
    <p v-if="showError" class="error--text font-italic">{{ $t('answerError') }}</p>
  </nav>
</template>
<script>

export default {
  props: {
    question: {
      type: Object,
      default: () => { }
    },
    role: {
      type: String,
      default: 'booster'
    },
    invalidAnswers: {
      type: Array,
      default: () => []
    },
    hasSubmittedSurvey: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      updateComponent: '',
      answerObject: {
        type: this.question.type,
        id: this.question.id,
        selections: []
      },
      showError: false
    }
  },
  created() {
    this.$emit('sendAnswer', this.answerObject)
  },
  watch: {
    invalidAnswers() {
      this.showError = false
      if (this.hasSubmittedSurvey && this.invalidAnswers.includes(this.question.id)) {
        this.showError = true
      }
    },
  },
  methods: {
    answerQuestion(answer) {
      answer.answer = !answer.answer
      this.updateComponent = Date.now()
      if (answer.answer) {
        this.answerObject.selections.push(answer.aid)
      } else {
        this.answerObject.selections.splice(this.answerObject.selections.indexOf(answer.aid), 1)
      }
      this.$emit('sendAnswer', this.answerObject)
    }
  }
}
</script>
<style scope>
.survey-answer-block .v-input__slot {
  display: block !important;
}
.survey-answer-block .v-text-field__slot {
  height: 0;
}
</style>